import KardiaRx from './KardiaRx';

export default KardiaRx;



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRx/index.js